const integrationsDictES = {
  // Integraciones
  integrations: "Integraciones",
  integrationsDescription:
    "Accede a herramientas y aplicaciones integradas listas para tus actividades en Extraconomy.",
  configure: "Configurar",
  integrationData: "Datos de integración",

  // WhatsApp
  whatsappIntegrationDescription: "Gestiona el número de contacto visible en tu tienda.",
  phoneNumber1: "Número de Teléfono",
  enterYourPhoneNumber: "Ingresa tu número de teléfono",
  confirmationCode: "Código de Confirmación",
  enterReceivedCode: "Ingresa el código recibido",
  goBackAndResendCode: "Volver y reenviar código",

  // Mensajes
  attention: "Atención",
  success: "Éxito",
  error: "Error",
  codeSent: "Código Enviado",
  codeSentTo: "Código enviado a",

  // Validaciones
  pleaseProvidePhoneNumber: "Por favor, proporciona el número de teléfono",
  pleaseProvideConfirmationCode: "Por favor, proporciona el código de confirmación",

  // Éxito
  confirmationCodeSentToWhatsApp: "Código de confirmación enviado a WhatsApp",
  whatsappConfiguredSuccessfully: "¡WhatsApp configurado con éxito!",
  configurationSavedSuccessfully: "Configuración guardada con éxito",

  // Errores
  errorConnectingToServer: "Error al conectar con el servidor",
  invalidConfirmationCode: "Código de confirmación inválido",
  errorConfirmingCode: "Error al confirmar código",
};

export default integrationsDictES;
